











import { mapGetters } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { StaffEntity } from '@/entities/staff.entity';
import BulletinCommentItem from '@/components/ViewComponent/Bulletin/BulletinComment/BulletinCommentItem.vue';
import { BulletinCommentEntity } from '@/entities/bulletin-comment.entity';
import { VSheet } from 'vuetify/lib';

const join = [
  'staff',
  'reactions',
  'reactions.emoticon',
];
@Component<BulletinCommentList>({
  components: {
    BulletinCommentItem,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
  created() {
    this.filter = [['bulletinId', '$eq', this.bulletinId]];
  },
})
export default class BulletinCommentList extends CreateListDataMixin<BulletinCommentEntity>(
  'bulletin-comment',
  'bulletin_comment',
  join,
) {
  endLoad = false;

  currentStaff: StaffEntity;

  @Prop({ type: Number })
  bulletinId: number;

  @Prop({ type: VSheet })
  refContainer: InstanceType<typeof VSheet>;

  @Watch('refContainer')
  async handleChangeRefContainer(val) {
    await this.$nextTick();
    if (val) val.$el.addEventListener('scroll', this.handleScroll);
  }

  destroyed() {
    this.refContainer.$el.removeEventListener('scroll', this.handleScroll);
  }

  mounted() {
    this.$cheeers.socket.on('bulletin_comment_created', (data: BulletinCommentEntity) => {
      const bulletinId = Number(this.$route.params.id);
      if (bulletinId === data.bulletinId) {
        this.prependItem(data.id);
      }
    });

    this.$cheeers.socket.on('bulletin_comment_destroy', (data: BulletinCommentEntity) => {
      const bulletinId = Number(this.$route.params.id);
      if (bulletinId === data.bulletinId) {
        this.removeItem(data.id);
      }
    });
  }

  async handleScroll(e) {
    if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight && !this.endLoad) {
      this.loading = true;
      let rows;
      [rows, , this.endOfPage] = await this.apiStore.nextPage().getMany();
      this.rawItems = [...this.rawItems, ...rows];
      this.loading = false;
      if (!rows.length) this.endLoad = true;
    }
  }
}
